module.exports = __webpack_public_path__ + "static/img/search.dbea487e.png";